import { Button } from "@dgs/core";
import { useField } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { EventAddress } from "../../types/event";

export const EventAddressClearButton: FC = () => {
	const [, , helper] = useField<EventAddress>("address");
	const onClearAddress = async () => {
		await helper.setValue({
			street: "",
			houseNumber: "",
			zip: "",
			city: "",
			country: null,
			additionalInfo: "",
		});
	};
	const { t } = useTranslation();

	return (
		<Button onClick={onClearAddress} title={t("Clear Address")} type="button" size="small">
			{t("Clear Address")}
		</Button>
	);
};
